(function($, angular, window) {
    'use strict';
    window.THF.Angular.JoinForm.filter("fieldAppendRequired", [function() {
        return function(content, validationRules) {
            if( typeof validationRules === 'object' && validationRules.length ) {
                if( validationRules.indexOf('required') >= 0 ) {
                    content += ' <span class="contourIndicator">*</span>';
                }
            }
            return content;
        }
    }]);

})(jQuery, angular, window);
